import styled from 'styled-components';
import React, { useEffect } from 'react';
import * as styles from './styles';
import { InvalidLinkContentProp } from './models';
import { EventsNames } from '~/enums/Events';
import { TrackCategory } from '@sunbit-dev/purchase-common/src/services/networkService/models';
import { useTranslation } from '@sunbit-dev/translations';
import { useTrack } from '~/hooks/track';
import brokenLinkIcon from '~/assets/broken-link.svg';

export const InvalidLinkContent = styled(({ className }: InvalidLinkContentProp) => {
  const { t } = useTranslation('message_page', { keyPrefix: 'invalid_link' });
  const { track } = useTrack();

  useEffect(() => {
    track({ eventName: EventsNames.linkIsMissingAToken, type: TrackCategory.Action });
  }, []);

  return (
    <div className={className}>
      <img className="broken-link-icon" src={brokenLinkIcon} alt={t('icon_label')} />
      <div className="text title">{t('title')}</div>
      <div className="text subtitle">{t('subtitle')}</div>
    </div>
  );
})`
  ${styles.InvalidLinkContent}
`;
